export default [
  {
    path: '/administrador/lives',
    name: 'livesAdministrador',
    component: () => import('./pages/List.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Lives',
      breadcrumb: [
        // {
        //   text: 'Perfil',
        //   active: true,
        // },
      ],
    },
  },
  {
    path: '/administrador/live/:slug/:live_id/palestrantes',
    name: 'livesVmix',
    component: () => import('./pages/vmix/List.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Live VMIX',
      breadcrumb: [
        // {
        //   text: 'Perfil',
        //   active: true,
        // },
      ],
    },
  },
]
